import * as React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { Box, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Result } from 'bloggers-backend/lib/domain/Result';
import Grid, { QueryOptions, QueryResult } from '../Grid';
import { AppContext } from '../../AppContext';

const columns: GridColDef[] = [
  {
    field: 'account.email',
    headerName: 'account',
    width: 220,
    filterable: true,
    sortable: true,
    valueGetter: (_value, row) => row?.account?.email,
    renderCell: ({ row }: any) => (
      <Link to={`/email-schedulers/${row?.id}`}>{row?.account?.email}</Link>
    ),
  },
  { field: 'active', headerName: 'active', width: 90, type: 'boolean', filterable: true, sortable: true },
];

export default function EmailSchedulersPage() {
  const { client, notificationsService } = React.useContext(AppContext);
  const navigate = useNavigate();

  const fetchData = async (options: QueryOptions): Promise<QueryResult> => {
    const result = await client<{}, Result<QueryResult>>({
      event: 'emailScheduler.getAll',
      data: options as any,
    });

    if (result.success) {
      return result.value;
    }

    notificationsService.notify({
      severity: 'error',
      message: `Error: ${JSON.stringify(result.errors)}`,
    });

    return { data: [], pageInfo: {} };
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ marginBottom: 1 }}>
        <Button variant="contained" onClick={() => navigate('/email-schedulers/new')}>
          CREATE NEW SCHEDULER
        </Button>
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <Grid
          cacheName={'email-schedulers'}
          columns={columns}
          fetchData={fetchData}
          onRowClick={() => {}}
        />
      </Box>
    </Box>
  );
}
